import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Skeleton.css';

const ImageSkeleton = ({ height, width, alternative, className }) => {
  const computedClass = classnames(
    styles.element,
    styles.image,
    { [styles.alternative]: alternative },
    className
  );
  return <span className={computedClass} style={{ height, width }} />;
};

ImageSkeleton.displayName = 'ImageSkeleton';

ImageSkeleton.propTypes = {
  /** define a height for the image skeleton */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** define a width for the image skeleton */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Set if you want an alternative colour (#D9D9D9) */
  alternative: PropTypes.bool,
  /** define a custom className for the skeleton */
  className: PropTypes.string,
};

export default ImageSkeleton;
